import { useFormikContext } from 'formik'
import Select from 'ui/components/forms/Select/'

export const ProjectOrganizationField = ({
  organizations,
  canEditProjectSettings = true,
}) => {
  const formik = useFormikContext()
  const meta = formik.getFieldMeta('organization_id')

  return (
    <Select
      options={organizations}
      value={meta.value}
      meta={meta}
      error={meta.touched ? meta.error : undefined}
      onChange={(newValue) => {
        formik.setFieldValue('organization_id', newValue || null)
      }}
      isClearable
      label="Юридическое лицо"
      id="legalEntity"
      defaultTitle="Любой"
      maxHeight="174px"
      placeholder="Выберите юридическое лицо"
      noMargin
      isDisabled={!canEditProjectSettings}
    />
  )
}
